/**
 * Created by suxiong on 2018/7/3.
 */
import axios from 'axios'
import {
  Message
} from 'element-ui'

import router from '../router/index'
// import qs from 'qs'

export const baseURL = '/'

var showed = false

function returnLogin() {
    showed = false

    router.replace({
        path: '/'
    })
}

const instance = axios.create({
    baseURL: baseURL,
    timeout: 6000000,
    withCredentials:true,
    // headers: {'SessionID': 'foobar'},
    // auth: {
    //     username: 'admin',
    //     password: '123'
    //   },
    //   proxy: {
    //     host: '127.0.0.1',
    //     port: 9095,
    //     auth: {
    //       username: 'admin',
    //       password: '123'
    //     }
    //   }
  });


// axios.defaults.headers = {
//     'SessionID': ''
// }

// axios.defaults.headers.post['Content-Type'] = 'application/json';

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

instance.interceptors.request.use(config => {
  return config;
}, err => {
  Message.error({
    message: '请求超时!'
  });
})


instance.interceptors.response.use(data => {
  if (data.status && data.status == 200 && data.data.status == 500) {
    // Message.error({
    //   message: data.data.msg
    // });
    return;
  }
//   if (data.data.msg) {
//     Message.success({
//       message: data.data.msg
//     });
//   }
  return data;
}, err => {
    if (!err.response || err.response.status == 504 || err.response.status == 404) {
        if (!showed) {
            showed = true
            Message.error({
                message: '服务器无法通信连接，请与系统管理员联系！',
                onClose: returnLogin
              });
        }
    }
    else if (err.response.headers.sessionstatus == 'timeout') {
   // Message.error({
   //   message: 'session过期!'
   // });
       router.replace('/index')

       setTimeout(function(){
            window.location.reload();
        }, 1500);

    } else if (!err.response || err.response.status == 504 || err.response.status == 404) {
    if (!showed) {
        showed = true
        Message.error({
            message: '服务器无法通信连接，请与系统管理员联系！',
            onClose: returnLogin
          });
    }
  } else if (err.response.status == 403) {
    Message.error({
      message: '权限不足,请与系统管理员联系!'
    });
  } else if (err.response.status == 401) {
    Message.error({
      message: err.response.data.msg
    });
  } else {
    if (err.response.data.msg) {
      Message.error({
        message: err.response.data.msg
      });
    } else {
      Message.error({
        message: '未知错误!'
      });
    }
  }
  // return Promise.resolve(err);
})


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    instance.get(baseURL + 'api/' + url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}


export const post = function (url, data) {
  return new Promise((resolve, reject) => {
    instance.post(baseURL + 'api/' + url, data)
      .then(res => {
          if(res){
            resolve(res.data);
         }else{
            if (!showed) {
                showed = true
                Message.error({
                    message: '服务器无法通信连接，请与系统管理员联系！',
                    onClose: returnLogin
                  });
            }
         }
      })
      .catch(err => {
        reject(err)
      })
  });
}


export const postFile = function (url, data) {
  return new Promise((resolve, reject) => {
    //根据data对象生成FormData对象
    var temp = new FormData();
    for (var t in data) {
      temp.append(t, data[t]);
    }
    let config = {
        //添加请求头
        headers: { "Content-Type": "multipart/form-data" }
      };

    instance.post(baseURL + 'api/' + url, temp , config).then((res) => {
      if (res) {
        resolve(res.data);
      }
    }).catch(err => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/untils/axios.js